function openTermsModal() {
  document.getElementById('terms-snippet-container').style.display = 'block';
  document.body.classList.add('modal-open');
}

function closeTermsModal() {
  document.getElementById('terms-snippet-container').style.display = 'none';
  document.body.classList.remove('modal-open');
}
function openSizeModal() {
  document.getElementById('size-guide-container').style.display = 'block';
  document.body.classList.add('modal-open');
}

function closeSizeModal() {
  document.getElementById('size-guide-container').style.display = 'none';
  document.body.classList.remove('modal-open');
}
function openPolicyModal() {
  document.getElementById('policy-snippet-container').style.display = 'block';
  document.body.classList.add('modal-open');
}

function closePolicyModal() {
  document.getElementById('policy-snippet-container').style.display = 'none';
  document.body.classList.remove('modal-open');
}
function openShippingModal() {
  document.getElementById('shipping-snippet-container').style.display = 'block';
  document.body.classList.add('modal-open');
}
function closeShippingModal() {
  document.getElementById('shipping-snippet-container').style.display = 'none';
  document.body.classList.remove('modal-open');
}

function openGiftcardModal() {
  document.getElementById('giftcard-snippet-container').style.display = 'block';
  document.body.classList.add('modal-open');
}
function closeGiftcardModal() {
  document.getElementById('giftcard-snippet-container').style.display = 'none';
  document.body.classList.remove('modal-open');
}

// Make functions available globally if needed
window.openTermsModal = openTermsModal;
window.closeTermsModal = closeTermsModal;
window.openSizeModal = openSizeModal;
window.closeSizeModal = closeSizeModal;
window.openPolicyModal = openPolicyModal;
window.closePolicyModal = closePolicyModal;
window.openShippingModal = openShippingModal;
window.closeShippingModal = closeShippingModal;
window.openGiftcardModal = openGiftcardModal;
window.closeGiftcardModal = closeGiftcardModal;

document.addEventListener("DOMContentLoaded", function () {
  function initAccordion() {
    const isMobile = window.innerWidth <= 768;
    const menuLinks = document.querySelectorAll(".menu-item.has-submenu > a");

    menuLinks.forEach((link) => {
      link.onclick = null;

      const parentLi = link.parentElement;
      const submenu = parentLi.querySelector(".accordion-submenu");
      const menuName = link.textContent.trim().toLowerCase();

      if (!submenu) return;

      // Save original submenu content
      if (!submenu.dataset.original) {
        submenu.dataset.original = submenu.innerHTML;
      }

      /* ---------------- SOCIAL MENU (NO ACCORDION) ---------------- */

      if (menuName === "social") {
        if (isMobile) {
          submenu.innerHTML = `
            <div class="social-icons" style="display:flex; gap:15px; margin-top:10px;margin-left:2px;align-items: center;">

            <a href="https://www.instagram.com/andreawazenofficial/" class="icon-facebook"> <span class="svg-wrapper " style="height:auto;width:22px"> 
            <svg width="800" height="800" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="M12 9.52A2.48 2.48 0 1 0 14.48 12 2.48 2.48 0 0 0 12 9.52m9.93-2.45a6.5 6.5 0 0 0-.42-2.26 4 4 0 0 0-2.32-2.32 6.5 6.5 0 0 0-2.26-.42C15.64 2 15.26 2 12 2s-3.64 0-4.93.07a6.5 6.5 0 0 0-2.26.42 4 4 0 0 0-2.32 2.32 6.5 6.5 0 0 0-.42 2.26C2 8.36 2 8.74 2 12s0 3.64.07 4.93a6.9 6.9 0 0 0 .42 2.27 3.9 3.9 0 0 0 .91 1.4 3.9 3.9 0 0 0 1.41.91 6.5 6.5 0 0 0 2.26.42C8.36 22 8.74 22 12 22s3.64 0 4.93-.07a6.5 6.5 0 0 0 2.26-.42 3.9 3.9 0 0 0 1.41-.91 3.9 3.9 0 0 0 .91-1.4 6.6 6.6 0 0 0 .42-2.27C22 15.64 22 15.26 22 12s0-3.64-.07-4.93m-2.54 8a5.7 5.7 0 0 1-.39 1.8A3.86 3.86 0 0 1 16.87 19a5.7 5.7 0 0 1-1.81.35H8.94A5.7 5.7 0 0 1 7.13 19a3.5 3.5 0 0 1-1.31-.86A3.5 3.5 0 0 1 5 16.87a5.5 5.5 0 0 1-.34-1.81V8.94A5.5 5.5 0 0 1 5 7.13a3.5 3.5 0 0 1 .86-1.31A3.6 3.6 0 0 1 7.13 5a5.7 5.7 0 0 1 1.81-.35h6.12a5.7 5.7 0 0 1 1.81.35 3.5 3.5 0 0 1 1.31.86A3.5 3.5 0 0 1 19 7.13a5.7 5.7 0 0 1 .35 1.81V12c0 2.06.07 2.27.04 3.06Zm-1.6-7.44a2.38 2.38 0 0 0-1.41-1.41A4 4 0 0 0 15 6H9a4 4 0 0 0-1.38.26 2.38 2.38 0 0 0-1.41 1.36A4.3 4.3 0 0 0 6 9v6a4.3 4.3 0 0 0 .26 1.38 2.38 2.38 0 0 0 1.41 1.41 4.3 4.3 0 0 0 1.33.26h6a4 4 0 0 0 1.38-.26 2.38 2.38 0 0 0 1.41-1.41 4 4 0 0 0 .26-1.38V9a3.8 3.8 0 0 0-.26-1.38ZM12 15.82A3.81 3.81 0 0 1 8.19 12 3.82 3.82 0 1 1 12 15.82m4-6.89a.9.9 0 0 1 0-1.79.9.9 0 0 1 0 1.79"/></svg> </span></a>

              <a href="https://www.facebook.com/andreawazenofficial/" class="icon-twitter">
                <span class="svg-wrapper" style="height:auto;width:21px;">
                  <svg width="800" height="800" viewBox="0 0 24 24" data-name="Flat Color" xmlns="http://www.w3.org/2000/svg" class="icon flat-color"><path d="M14 6h3a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-3a5 5 0 0 0-5 5v3H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2v7a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-7h2.22a1 1 0 0 0 1-.76l.5-2a1 1 0 0 0-1-1.24H13V7a1 1 0 0 1 1-1" style="fill:#000"/></svg>
                </span>
              </a>

              <a href="https://www.linkedin.com/company/andrea-wazen/" class="icon-instagram">
                <span class="svg-wrapper" style="height:auto;width:20px">
                  <svg width="800" height="800" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.959 11.719v7.379h-4.278v-6.885c0-1.73-.619-2.91-2.167-2.91-1.182 0-1.886.796-2.195 1.565-.113.275-.142.658-.142 1.043v7.187h-4.28s.058-11.66 0-12.869h4.28v1.824c.568-.875 1.583-2.126 3.856-2.126 2.815 0 4.926 1.84 4.926 5.792M2.421.026C.958.026 0 .986 0 2.249c0 1.235.93 2.224 2.365 2.224h.028c1.493 0 2.42-.989 2.42-2.224C4.787.986 3.887.026 2.422.026zM.254 19.098h4.278V6.229H.254z"/>
                  </svg>
                </span>
              </a>

            </div>
          `;

          // show submenu without accordion
          submenu.style.maxHeight = "none";
          parentLi.classList.remove("open");
          link.onclick = null;

        } else {

          // restore desktop submenu
          submenu.innerHTML = submenu.dataset.original;
          submenu.style.maxHeight = null;
          parentLi.classList.remove("open");
          link.onclick = null;
        }

        return;
      }

      /* ---------------- NORMAL ACCORDION ---------------- */

      if (isMobile) {
        link.onclick = function (e) {
          e.preventDefault();

          document.querySelectorAll(".menu-item.has-submenu").forEach((li) => {
            const otherSubmenu = li.querySelector(".accordion-submenu");

            if (li !== parentLi && otherSubmenu) {
              otherSubmenu.style.maxHeight = null;
              li.classList.remove("open");
            }
          });

          if (submenu.style.maxHeight) {
            submenu.style.maxHeight = null;
            parentLi.classList.remove("open");
          } else {
            submenu.style.maxHeight = submenu.scrollHeight + "px";
            parentLi.classList.add("open");
          }
        };

      } else {

        submenu.style.maxHeight = null;
        parentLi.classList.remove("open");
      }
    });
    document.querySelectorAll(".menu-item.has-submenu").forEach((item) => {
  const link = item.querySelector("a");

  if (link && link.textContent.trim().toLowerCase() === "social") {
    item.classList.add("social");
  }
});
  }

  initAccordion();

  window.addEventListener("resize", initAccordion);
});